import { useMediaQuery } from '@mui/material';
import {
  MDTailwindMinPixelBreakpointWidth,
  SMTailwindMinPixelBreakpointWidth,
  LGTailwindMinPixelBreakpointWidth,
} from '../../util/theme.util';

export function useIsMediumViewport() {
  return useMediaQuery(`(max-width: ${MDTailwindMinPixelBreakpointWidth}px)`);
}

export function useIsSmallViewport() {
  return useMediaQuery(`(max-width: ${SMTailwindMinPixelBreakpointWidth}px)`);
}

export function useIsLargeViewport() {
  return useMediaQuery(`(min-width: ${LGTailwindMinPixelBreakpointWidth}px)`);
}
